// src/components/signupSteps/Step4Preferences.jsx
import React, { useRef } from "react";
import images from "../../utils/images";
import authStyle from "../../style/layouts/auth.module.css";
import Step3ProfileStyle from "../../style/components/RegisterSteps/Step3ProfileInfo.module.css";
import AuthInputField from "../ui/input/AuthInputs";
import mainstyle from "../../style/Main.module.css";

const Step4CompanyInfo = ({
  formData,
  onChange,
  errors,
  setSelectedImage,
  selectedImage,
}) => {
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      onChange({
        target: {
          name: "company_logo",
          value: null,
          error: "Please upload an image file",
        },
      });
      return;
    }

    // Preview for frontend
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);

    // Store actual File object in formData
    onChange({
      target: {
        name: "company_logo",
        value: file,
      },
    });
  };

  return (
    <div>
      <h3 className={mainstyle.FontSizeHeading20}>
        Please fill in the following information to set up your company profile.
      </h3>

      <AuthInputField
        label="Company Name"
        name="company_name"
        value={formData?.company_name || ""}
        onChange={onChange}
        error={errors.company_name}
        required
      />

      <AuthInputField
        label="Email Address"
        name="company_email"
        type="email"
        value={formData?.company_email || ""}
        onChange={onChange}
        error={errors.company_email}
        required
      />

      <AuthInputField
        label="Phone"
        name="company_phone_num"
        value={formData?.company_phone_num || ""}
        onChange={onChange}
        error={errors.company_phone_num}
        required
      />

      <label>
        Logo<span className={mainstyle.mantitory}>*</span>
      </label>
      <div className={authStyle.imageUploadViewauth}>
        <div
          onClick={handleImageClick}
          className={Step3ProfileStyle.Step3ProfileInfoinputdiv}
        >
          <img
            id="preview-image"
            src={selectedImage || images.userDemo}
            alt="Company Logo"
          />
        </div>
        <input
          type="file"
          accept="image/*"
          name="company_logo"
          onChange={handleImageUpload}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
      </div>

      {errors.company_logo && (
        <span
          className={mainstyle.errorMsg}
          style={{ marginBottom: "10px", marginTop: "10px" }}
        >
          {errors.company_logo}
        </span>
      )}
      <br />
    </div>
  );
};

export default Step4CompanyInfo;
